import React from 'react';
import {MainLayout} from 'components/layouts';
import FormCreateFair from 'components/fair/FormCreateFair.jsx';
import {Fairs} from 'base/api';
import {Link} from 'react-router-dom';

class EditFair extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      fair: {}
    }
  }

  cb(response) {
    this.props.history.push('/fairs');
  }

  componentDidMount() {
    Fairs.actions.get.request({id: this.props.match.params.id}, {filter:{"include": {"relation":"categories","scope": {"where": {"parentId": null},"include":"children"}}}}).then(response => {
      this.setState({
        fair: response.data && response.data.fair
      })
    })
  }

  render() {
    return (
      <MainLayout>
        <div>
          <div className='mb15'>
            <Link className='btn-back' to={`/fairs`}><i className='fa fa-chevron-left' />Quay về trang danh sách</Link>
          </div>
          <div className='wrap-heading'>
            <h1>Chỉnh sửa hội chợ</h1>
          </div>
          <FormCreateFair fnSubmit={Fairs.actions.update} cb={this.cb.bind(this)} data={this.state.fair}/>
        </div>
      </MainLayout>
    );
  }
}

EditFair.contextTypes = {
  router: React.PropTypes.object
};

export default EditFair;


// WEBPACK FOOTER //
// ./pages/fair/Edit.jsx